import { createContext } from 'react'

const OfferPageAssistantExpandedContext = createContext<boolean>(false)

export default OfferPageAssistantExpandedContext
